/*global $:false, location:false, window:false, _:false, Modernizr: false */

$(function () {
  'use strict'

  var $socialServices = $('.social-services .social-services__service'),
    socialServiceAttachedClass = 'social-services__service_attached',
    socialServiceActiveClass = 'social-services__service_active',
    $errors = $('.social-services__attach-error')

  var $socialServiceSwitchers = $socialServices.find('.social-services__service__switcher');

  function attachSocial ($service) {
    var serviceName = $service.data('service')
    if (!serviceName) {
      return false
    }

    socialAttached(serviceName, true)

    var url,
      title = $service.attr('title'),
      width = 480,
      height = 380

    if (serviceName === 'vk') {
      width = 550
      height = 420
    } else if (serviceName === 'facebook') {
      width = 700
      height = 555
    }
    url = $service.data('attachUrl')

    var top = screen.height / 2 - height / 2
    var left = screen.width / 2 - width / 2
    window.targetWin = window.open(url, title,
      'toolbar=0, location=0, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left)

    // Следим за состоянием попап окна,
    // если оно закрыто до того как успело отработать — посылаем cancel
    $(window).on('focus.targetWinWatch', function () {
      setTimeout(function () {
        if (window.targetWin.closed) {
          $service.trigger('social-attached', [
            {result: 'cancel'}
          ])
        }
      }, 200)
    })
  }

  function detachSocial ($service) {
    var serviceName = $service.data('service')
    socialDetached(serviceName, true)

    $.post($service.data('detachUrl'))
      .done(function () {
        socialDetached(serviceName)
      })
      .fail(function (xhr) {
        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          showErrors(xhr.responseJSON.error)
        }
        else if (typeof (xhr.responseText) !== 'undefined') {
          var response = JSON.parse(xhr.responseText)
          showErrors(response.error)
        }
        else {
          showErrors('')
        }

        socialAttached(serviceName)
      })
  }

  function socialAttached (serviceName, switchOnly) {
    if (!switchOnly) {
      $(window).off('focus.targetWinWatch') // Можно больше не следить на попапом
      $socialServices.data('disabled', false)
    }
    var $serviceBlocks = $socialServices.filter('[data-service="' + serviceName + '"]')
    $serviceBlocks.addClass(socialServiceAttachedClass)
    $serviceBlocks.data('attached', true)
  }

  function socialDetached(serviceName, switchOnly) {
    if (!switchOnly) {
      $(window).off('focus.targetWinWatch') // Можно больше не следить на попапом
      $socialServices.data('disabled', false)
      $socialServices.removeClass(socialServiceActiveClass)
    }
    var $serviceBlocks = $socialServices.filter('[data-service="' + serviceName + '"]')
    $serviceBlocks.removeClass(socialServiceAttachedClass)
    $serviceBlocks.data('attached', false)
  }

  function showErrors (error) {
    $errors.text(error || 'Произошла ошибка, попробуйте повторить попытку')
    $errors.show()
  }

  function triggerService ($service) {
    if (!$service.data('disabled')) {
      $errors.hide()
      $socialServices.data('disabled', true)
      $service.addClass(socialServiceActiveClass)

      if ($service.data('attached')) {
        detachSocial($service)
      }
      else {
        attachSocial($service)
      }
    }
  }

  $(document).on('ready', function () {

    $socialServices.on('')

    $socialServiceSwitchers.on('click', function (e) {
      e.preventDefault()
      var $service = $(this).closest($socialServices)
      triggerService($service)
    })

    $socialServices.bind('social-attached', function (e, data) {
      if ($(this).hasClass('redirect-after-attach')) {
        location.reload()
      }
      else {
        var serviceName = $(this).data('service')
        switch (data.result) {
          case 'cancel':
            showErrors('')
            socialDetached(serviceName)
            break;
          case 'error':
            showErrors(data.error)
            socialDetached(serviceName)
            break;
          default:
            socialAttached(serviceName)
            break;
        }
      }
    })
  })
});
